import { ArrowUpRight, Sparkles } from "lucide-react";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 sm:py-32 bg-[#F5ECE1]/40 border-y border-[#E8E1DA]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal lg:sticky lg:top-32">
            <p className="overline">Complimentary Consultation</p>
            <h2 className="font-serif-luxe mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[#2C2723]">
              Every journey begins with a{" "}
              <em className="text-[#8C6A53]">personalised</em> conversation.
            </h2>
            <p className="mt-8 text-[15px] leading-relaxed text-[#5C534B] max-w-md">
              At Face It Aesthetics, every treatment journey begins with a
              personalised consultation — no pressure, no obligation.
            </p>

            <a
              href="#contact"
              data-testid="services-consult-cta"
              className="btn-luxe mt-10 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#2C2723] text-white text-sm tracking-wide"
            >
              Book Your Complimentary Consultation <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-7 space-y-5 reveal" style={{ transitionDelay: "120ms" }}>
            <article className="bg-white border border-[#E8E1DA] rounded-3xl p-8 lg:p-10">
              <div className="flex items-start gap-4">
                <span className="text-xs tracking-[0.28em] text-[#8C6A53] mt-1">01</span>
                <div>
                  <h3 className="font-serif-luxe text-2xl sm:text-3xl text-[#2C2723] leading-snug">
                    Why can&rsquo;t I see a treatment or price menu?
                  </h3>
                  <p className="mt-4 text-[14px] leading-relaxed text-[#5C534B]">
                    You may notice that our website does not display a list of
                    specific injectable treatments or treatment prices. This is
                    because of{" "}
                    <span className="text-[#2C2723]">
                      Therapeutic Goods Administration (TGA) advertising
                      requirements
                    </span>{" "}
                    in Australia. Certain cosmetic treatments involve
                    prescription-only medicines, which cannot be advertised or
                    promoted directly to the public.
                  </p>
                  <p className="mt-4 text-[14px] leading-relaxed text-[#5C534B]">
                    For this reason, we do not publish a public treatment menu
                    or price list for these services.
                  </p>
                </div>
              </div>
            </article>

            <article className="bg-white border border-[#E8E1DA] rounded-3xl p-8 lg:p-10">
              <div className="flex items-start gap-4">
                <span className="text-xs tracking-[0.28em] text-[#8C6A53] mt-1">02</span>
                <div>
                  <h3 className="font-serif-luxe text-2xl sm:text-3xl text-[#2C2723] leading-snug">
                    What happens instead?
                  </h3>
                  <p className="mt-4 text-[14px] leading-relaxed text-[#5C534B]">
                    Instead, we offer a{" "}
                    <span className="text-[#2C2723]">
                      complimentary consultation
                    </span>{" "}
                    where we can discuss your individual concerns, goals and
                    expectations, and assess which treatment options may be
                    appropriate for you.
                  </p>
                  <p className="mt-4 text-[14px] leading-relaxed text-[#5C534B]">
                    Your treatment plan and associated costs will be discussed
                    with you privately following your consultation.
                  </p>
                </div>
              </div>
            </article>

            <article className="bg-[#2C2723] text-[#F5ECE1] rounded-3xl p-8 lg:p-10 flex items-center justify-between gap-6 flex-wrap">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#F5ECE1]/10 flex items-center justify-center">
                  <Sparkles size={18} className="text-[#D9C5B2]" />
                </div>
                <div>
                  <p
                    className="overline"
                    style={{ color: "#D9C5B2", letterSpacing: "0.32em" }}
                  >
                    Complimentary Consultation
                  </p>
                  <p className="font-serif-luxe text-xl sm:text-2xl mt-1">
                    No Obligation.
                  </p>
                </div>
              </div>
              <a
                href="#contact"
                data-testid="services-consult-secondary"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#F5ECE1] text-[#2C2723] text-sm tracking-wide hover:bg-[#D9C5B2] transition-colors"
              >
                Begin <ArrowUpRight size={14} />
              </a>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
